import { useAuth } from '@/context/AuthContext';
import styles from './Checkout.module.css';

/**
 * Stands in for the delivery address on a digital order.
 *
 * There is nothing to post — the books open in playTUB — so instead of asking
 * where to send them, this says which account they'll appear on. That account is
 * the playTUB login, which is why checkout asks to sign in before taking payment.
 */
export function DigitalAccessSection({ step }) {
  const { user, isSignedIn } = useAuth();

  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>
        <span className={styles.step}>{step}</span>Where your books go
      </h2>

      <div className={styles.digitalNote}>
        <div className={styles.digitalBadge}>Digital</div>
        <p className={styles.digitalText}>
          These are digital editions — they open in the playTUB app, so there&apos;s nothing to
          ship and no delivery address to fill in.
        </p>
      </div>

      <div className={styles.digitalAccount}>
        {isSignedIn ? (
          <>
            Unlocking on <strong>{user.username}</strong>
            {user.display_name && user.display_name !== user.username && ` (${user.display_name})`}
          </>
        ) : (
          <>You&apos;ll sign in with your playTUB account when you pay — that&apos;s the account
          the books are added to.</>
        )}
      </div>
    </section>
  );
}
